module.exports = __webpack_public_path__ + "img/product-shansuan-qt-01.c0b40c33.png";